import * as z from "zod/v4";

// Enum for global search categories
// Used across admin UI, command palette, and RPC filtering
export const globalSearchCategory = [
  "orders",
  "returns",
  "customers",
  "conversations",
  "pages",
  "documentation",
] as const;

export type GlobalSearchCategory = (typeof globalSearchCategory)[number];

// Zod schema for validation
export const GlobalSearchCategorySchema = z.enum(globalSearchCategory);
